/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */

import CommentsSection from '../../common/CommentsSection';

const FFIEC009Comment = ({
    getFFIEC009User, ffiec009Comment, setFFIEC009Comment, commentLoading, addFFIEC009Comment,
    loading, getUserCommentsForFFIEC009, ffiec009Edit, handleFFIC009Click, ffiec009Show,
    ffiec009Target, onFFIEC009EditClick, onFFIEC009ClickDelete, ffiec009SelectedIndex,
    ffiec009SelectedComment, setFFIEC009SelectedComment, onFFIEC009CancelClick, onFFIEC009ClickSave,
}) => (
    <CommentsSection
        getUser={getFFIEC009User}
        comment={ffiec009Comment}
        setComment={setFFIEC009Comment}
        commentLoading={commentLoading}
        addComment={addFFIEC009Comment}
        loading={loading}
        getUserComments={getUserCommentsForFFIEC009}
        edit={ffiec009Edit}
        handleClick={handleFFIC009Click}
        show={ffiec009Show}
        target={ffiec009Target}
        onEditClick={onFFIEC009EditClick}
        onClickDelete={onFFIEC009ClickDelete}
        selectedIndex={ffiec009SelectedIndex}
        selectedComment={ffiec009SelectedComment}
        setSelectedComment={setFFIEC009SelectedComment}
        onCancelClick={onFFIEC009CancelClick}
        onClickSave={onFFIEC009ClickSave}
    />
);

export default FFIEC009Comment;
